import { UserType } from "globals/types/models.ts";
import { EnumUserTypeType } from "globals/types/globals.ts";


function getValuesToCheck(type: EnumUserTypeType): (keyof UserType)[] {
  let values: (keyof UserType)[] = [];
  switch (type) {
    case "viewer":
      values = [
        "name",
        "email"
      ];
      break;
    case "event-manager":
      values = [
        "name",
        "email",
        "phoneNumber",
        "address",
        "city",
        "zipcode",
        "state",
        "country",
        "billingAddress",
        "billingZipcode",
        "billingCity",
        "billingState",
        "billingCountry",
        "planType"
      ];
      break;
    default:
      break;
  }

  return values;
}

export const getUserNotCompletedFields = (user: UserType | null): (keyof UserType)[] => {
  const fields: (keyof UserType)[] = [];
  if (!user) return fields;

  const valuesToCheck = getValuesToCheck(user.type);
  for (const value of valuesToCheck) {
    if (!user[value]) {
      fields.push(value);
    }
  }
  return fields;
};

export const getUserIsCompleted = (user: UserType | null): boolean => {
  if (!user) return false;
  const valuesToCheck = getValuesToCheck(user.type);
  for (const value of valuesToCheck) {
    if (!user[value]) return false;
  }
  return true;
};
